import { Fragment, useState, useEffect } from 'react'
import { Transition } from '@headlessui/react'
import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline' // Import additional icons as needed
import { XMarkIcon } from '@heroicons/react/24/solid'

export default function Notify({ message = "Editor Invited Successfully!", icon = "check", show, setShow }) {
  // Determine which icon to use
  const Icon = icon === "check" ? CheckCircleIcon : icon === "exclamation" ? ExclamationCircleIcon : CheckCircleIcon; // Default to CheckCircleIcon

  useEffect(() => {
    if (show) {
      // Automatically hide the notification after a certain time
      const timer = setTimeout(() => {
        setShow(false);
      }, 3000); // Adjust time as needed

      return () => clearTimeout(timer);
    }
  }, [show, setShow]);

  return (
    <>
      <div aria-live="assertive" className="fixed inset-0 flex items-end px-4 py-6 z-10 mt-10 pointer-events-none sm:p-6 sm:items-start">
        <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
         <Transition
  show={true} // or some state variable that evaluates to true or false
  as={Fragment}
  enter="transform ease-out duration-300 transition"
  enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
  enterTo="translate-y-0 opacity-100 sm:translate-x-0"
  leave="transition ease-in duration-100"
  leaveFrom="opacity-100"
  leaveTo="opacity-0"
>
            <div className="max-w-sm w-full bg-neutral-900 shadow-lg rounded-lg pointer-events-auto ring-1 ring-white ring-opacity-5 overflow-hidden">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <Icon className="h-6 w-6 text-green-400" aria-hidden="true" />
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm Gilroy-Medium text-white">{message}</p>
                  </div>
                  <div className="ml-4 flex-shrink-0 flex">
                    <button className="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none" onClick={() => setShow(false)}>
                      <span className="sr-only">Close</span>
                      <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  )
}